export default {
	required: "Este campo é obrigatório",
	requiredField: "O campo {field} é obrigatório",
	email: "Formato de email inválido",
	minLength: "O campo {field} deve ter pelo menos {min} caracteres",
	maxLength: "O campo deve ter no máximo {max} caracteres",
	passwordMismatch: "As senhas não conferem",
	cpfDigits: "CPF deve ter 11 dígitos",
	cpfInvalid: "CPF inválido — confira os números",
	zipCodeDigits: "CEP deve ter 8 dígitos",
	invalidPhone: "Telefone inválido",
};
